import React, { useEffect, useState } from 'react';
import { LockIcon } from 'lucide-react';
import type { DocumentType, Member } from '../../types';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Field, inputClass } from '../ui/Field';
import { useApp } from '../../contexts/AppContext';
interface PersonalDataModalProps {
  member: Member;
  open: boolean;
  onClose: () => void;
  /** Vodstvo lahko ureja tudi datum pridružitve. */
  dovoliPridruzitev?: boolean;
}
export function PersonalDataModal({
  member,
  open,
  onClose,
  dovoliPridruzitev = false
}: PersonalDataModalProps) {
  const {
    updateMember,
    pushToast
  } = useApp();
  const [osnutek, setOsnutek] = useState<Member>(member);
  useEffect(() => {
    if (open) setOsnutek(member);
  }, [open, member]);
  return <Modal open={open} onClose={onClose} naslov="Uredi osebne podatke" opis="Podatke vidite samo vi in pooblaščeni skrbnik zbora." sirina="max-w-2xl" noga={<>
          <Button variant="secondary" onClick={onClose} data-id="element-388" data-mp="347aqlpqx7mzq">
            Prekliči
          </Button>
          <Button onClick={() => {
      updateMember(osnutek);
      pushToast('Osebni podatki so shranjeni.');
      onClose();
    }} data-id="element-389" data-mp="2z999vbgyvzrf">
            Shrani podatke
          </Button>
        </>} data-id="element-387" data-mp="125rkhd7w65sc">
      <div className="space-y-4" data-id="element-390" data-mp="390nfm0zihvt0">
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-391" data-mp="2l8q7okz6nnx6">
          <Field label="E-naslov" htmlFor="pd-email" data-id="element-392" data-mp="2l98ak0gcp0e2">
            <input id="pd-email" value={osnutek.email} onChange={e => setOsnutek({
            ...osnutek,
            email: e.target.value
          })} className={inputClass} data-id="element-393" data-mp="2gaexua8w1dey" />
          </Field>
          <Field label="Telefon" htmlFor="pd-tel" data-id="element-394" data-mp="2q6hw350mcrwm">
            <input id="pd-tel" value={osnutek.telefon} onChange={e => setOsnutek({
            ...osnutek,
            telefon: e.target.value
          })} className={inputClass} data-id="element-395" data-mp="9j5ojkub9c2t" />
          </Field>
        </div>

        <Field label="Naslov" htmlFor="pd-naslov" data-id="element-396" data-mp="2ybso59i2a5dl">
          <input id="pd-naslov" value={osnutek.naslov ?? ''} onChange={e => setOsnutek({
          ...osnutek,
          naslov: e.target.value
        })} placeholder="Ulica in hišna številka" className={inputClass} data-id="element-397" data-mp="33b5e4348bske" />
        </Field>

        <div className="grid gap-4 sm:grid-cols-2" data-id="element-398" data-mp="3c9qz04x6bjoc">
          <Field label="Poštna številka" htmlFor="pd-post" data-id="element-399" data-mp="2fn474ymp8k73">
            <input id="pd-post" value={osnutek.postnaStevilka ?? ''} onChange={e => setOsnutek({
            ...osnutek,
            postnaStevilka: e.target.value
          })} className={inputClass} data-id="element-400" data-mp="2kknvwsh0wfda" />
          </Field>
          <Field label="Pošta" htmlFor="pd-posta" data-id="element-401" data-mp="2teirp9w98tg9">
            <input id="pd-posta" value={osnutek.posta ?? ''} onChange={e => setOsnutek({
            ...osnutek,
            posta: e.target.value
          })} className={inputClass} data-id="element-402" data-mp="1wvuz6tsku3hm" />
          </Field>
        </div>

        <div className="grid gap-4 sm:grid-cols-2" data-id="element-403" data-mp="1tcmah2xrjc82">
          <Field label="Datum rojstva" htmlFor="pd-rojstvo" data-id="element-404" data-mp="1oe2pb4qzu4gr">
            <input id="pd-rojstvo" type="date" value={osnutek.datumRojstva ?? ''} onChange={e => setOsnutek({
            ...osnutek,
            datumRojstva: e.target.value
          })} className={inputClass} data-id="element-405" data-mp="1ochwbjkbutl0" />
          </Field>
          <Field label="Datum pridružitve" hint={dovoliPridruzitev ? undefined : 'Ureja tajnik zbora.'} htmlFor="pd-pridruzitev" data-id="element-406" data-mp="1afumwhb6uay7">
            <input id="pd-pridruzitev" type="date" value={osnutek.clanOd} disabled={!dovoliPridruzitev} onChange={e => setOsnutek({
            ...osnutek,
            clanOd: e.target.value
          })} className={`${inputClass} disabled:bg-canvas disabled:text-ink-muted`} data-id="element-407" data-mp="10pjiktnldzqs" />
          </Field>
        </div>

        <div className="grid gap-4 sm:grid-cols-2" data-id="element-408" data-mp="2mqyhfqw3hn7d">
          <Field label="Vrsta osebnega dokumenta" htmlFor="pd-doktip" data-id="element-409" data-mp="2mtb7krc0b3vi">
            <select id="pd-doktip" value={osnutek.dokumentTip ?? ''} onChange={e => setOsnutek({
            ...osnutek,
            dokumentTip: (e.target.value || undefined) as DocumentType | undefined
          })} className={inputClass} data-id="element-410" data-mp="2rp02ghd2zwlh">
              <option value="" data-id="element-411" data-mp="282tx6ihe93mh">— ni izbrano —</option>
              <option value="osebna" data-id="element-412" data-mp="283n87vndyfaf">Osebna izkaznica</option>
              <option value="potni_list" data-id="element-413" data-mp="1u3ksog2jvxyc">Potni list</option>
            </select>
          </Field>
          <Field label="Številka osebnega dokumenta" htmlFor="pd-dokst" data-id="element-414" data-mp="1z0uhbti485l4">
            <input id="pd-dokst" value={osnutek.dokumentStevilka ?? ''} onChange={e => setOsnutek({
            ...osnutek,
            dokumentStevilka: e.target.value
          })} placeholder="Npr. PB1234567" className={inputClass} data-id="element-415" data-mp="3ogttzkky0d5i" />
          </Field>
        </div>

        <Field label="Posebnosti pri prehrani" hint="Npr. vegetarijanska prehrana, alergije, brez glutena." htmlFor="pd-prehrana" data-id="element-416" data-mp="1cu03a1x35zm1">
          <input id="pd-prehrana" value={osnutek.prehrana ?? ''} onChange={e => setOsnutek({
          ...osnutek,
          prehrana: e.target.value
        })} className={inputClass} data-id="element-417" data-mp="1mreki3qu2sfe" />
        </Field>

        <p className="flex items-start gap-2 rounded-lg bg-canvas px-3 py-2.5 text-xs leading-relaxed text-ink-muted" data-id="element-418" data-mp="1viojwbojdis0">
          <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-419" data-mp="2aggxgyaivx3k" />
          Naslov, datum rojstva, podatki o dokumentu in posebnosti pri prehrani so zasebni. Drugi člani jih
          ne vidijo. Ob gostovanjih organizator vidi le, ali so podatki popolni.
        </p>
      </div>
    </Modal>;
}